module.exports = __webpack_public_path__ + "static/media/mesa-tutorial.c08cb3d4.mp4";